import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CountyInput from './CountyInput.jsx';

function AdminCountyTagSelect({
  onChange,
  value,
  errors,
  counties
}) {
  const hideSelectAll = value.length == counties.length;
  const hideDeselectAll = value.length == 0;
  return (
    <div>
      <CountyInput
        label={<div style={{marginBottom: '11px'}}></div>}
        value={value}
        onChange={onChange}
        placeholder={'Counties'}
        selectProps={{ multi: true }}
        errors={errors}
      />
      <div>
        <a className={`${hideSelectAll && 'hide'}`}
          href="javascript:void(0)" onClick={() => {
          onChange(counties)
        }}>
          Select all
        </a>&nbsp;
        <a className={`${hideDeselectAll && 'hide'}`}
          href="javascript:void(0)" onClick={() => {
          onChange([])
        }}>
          Deselect all
        </a>
      </div>
    </div>
  );
}

AdminCountyTagSelect.defaultProps = {};

AdminCountyTagSelect.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  errors: PropTypes.array,
  counties: PropTypes.array
};

const mapStateToProps = (state) => ({
  counties: state.suggestions.county.values
})

export default connect(mapStateToProps)(AdminCountyTagSelect);



// WEBPACK FOOTER //
// ./src/containers/Input/AdminCountyTagSelect.jsx